import { Observable } from 'rxjs/Rx';
import { URLSearchParams, ResponseContentType } from '@angular/http';
import { BaseDataService } from '../../../classes/base-data-service';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { StoreService } from '../../../services/store.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ReservationCreate } from '../modules/reservation-create-module/models/reservation-create';

@Injectable()
export class ReservationService extends BaseDataService {
    constructor(http: Http, storeService: StoreService, authenticationService: AuthenticationService) {
        super(http, 'Reservation', storeService, authenticationService);
    }

    createInvitation(model: ReservationCreate) {
        this.setCustomEndpoint('CreateInvitation');

		return this.postWithData(model, {
			responseType: ResponseContentType.Text
		})
	}

    cancelReservationByReservationIdList (reservationIdList) {
        this.setCustomEndpoint('CancelReservation');
        return this.executePost({
            ReservationIdList: reservationIdList
        });
    }

    cancelReservationByReservationCustomerIdList (reservationCustomerIdList) {
        this.setCustomEndpoint('CancelReservation');
        return this.executePost({
            ReservationCustomerIdList: reservationCustomerIdList
        });
    }

    cancelReservationByReservationSeatIdList (reservationSeatIdList) {
        this.setCustomEndpoint('CancelReservation');
        return this.executePost({
            ReservationSeatIdList: reservationSeatIdList
        });
    }

    acceptInvitation (reservationCode) {
        this.setCustomEndpoint('RsvpAction');
        return this.executePost({
            ResponseType: 1,
            InviteCode: reservationCode
        });
    }
    reservationBulkImport (formData: FormData) {
        this.setCustomEndpoint('BulkCreateReservations');
        return this.executePostFormData(formData);
    }
    
    getSeatsForGroupSale(reservationCode: any, performanceId: any): Observable<any> {
        this.setCustomEndpoint('GetSeatsForGroupSale');
        return this.getWithParams([
            {key: 'reservationCode', value: reservationCode},
            {key: 'performanceId', value: performanceId}
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/reservation-module/services/reservation.service.ts